/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intakecontinue1Inputs */

const en_intakecontinue1 = /** @type {(inputs: Intakecontinue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue to chat →`)
};

const pt_intakecontinue1 = /** @type {(inputs: Intakecontinue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar para o chat →`)
};

/**
* | output |
* | --- |
* | "Continue to chat →" |
*
* @param {Intakecontinue1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakecontinue1 = /** @type {((inputs?: Intakecontinue1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakecontinue1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakecontinue1(inputs)
	return pt_intakecontinue1(inputs)
});
export { intakecontinue1 as "intakeContinue" }